import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectBusinessCustomEmbedRoute: InvariantJiraRoute = {
	name: 'issue-navigator-core-custom-embed',
	path: '/jira/core/projects/:projectKey/issues/:navigationItemId/embed',
};
